import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { rcmaRegExp, rcmaRegExpSimple } from 'enums/regExp';

export const rcmaValidation = () => [
    // inak to nefunguje a uz na to nemam nervy
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || rcmaRegExp.test(value)) return Promise.resolve();
            if (value && !rcmaRegExp.test(value)) return Promise.reject(<TranslateText>INVALID_RCMA</TranslateText>);
            return Promise.resolve();
        }
    })
];
export const rcmaValidationSimple = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || rcmaRegExpSimple.test(value)) return Promise.resolve();
            if (value && !rcmaRegExpSimple.test(value))
                return Promise.reject(<TranslateText>INVALID_RCMA</TranslateText>);
            return Promise.resolve();
        }
    })
];

export default rcmaValidation;
